import React from 'react';
//import parse from 'html-react-parser';
import { makeStyles } from '@material-ui/core/styles';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ReactMarkdown from 'react-markdown';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 790,
    width:'100%',
    margin:'auto'
  },
  heading: {
    fontSize: theme.typography.pxToRem(21),
    fontWeight: theme.typography.fontWeightMedium,
    paddingTop:6,
    paddingBottom:6,
  },
  content: {
    paddingTop:2,
    '& p': {
      lineHeight:'1.7'
    },
    '& ul li': {
      lineHeight:'1.7',
      padding: '2px 0px'
    }
  }
}));

const FaqBlock = ({ faqData }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
    { faqData.map((faq, index) => {
      return (
        <Accordion key={`faq-${index}`}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.content}>
            <Typography component="div">
              <ReactMarkdown>{faq.answer}</ReactMarkdown>
            </Typography>
          </AccordionDetails>
        </Accordion>
      );
    })}
    </div>
  )
}

export default FaqBlock;
